module.exports = __webpack_public_path__ + "img/supportmaintain.5dba26d0.svg";